/**
 * @generated SignedSource<<07c57311d4b2f2de5e0c9690ebcefe17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentAppSetupModalFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "ContentAppSetupModalFragment";
};
export type ContentAppSetupModalFragment$key = {
  readonly " $data"?: ContentAppSetupModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAppSetupModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentAppSetupModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "20ad2ce5955440baddf3f8b592c3f48f";

export default node;
